import * as api from '../resources/manage-inventory.api';
import actionTypes from './action-types';

export const fetchPacksGrossValueListRequest = () => ({
  type: actionTypes.FETCH_PACKS_GROSS_VALUE_LIST_REQUEST,
  name: 'manageInventoryLoadingStatus',
});

export const fetchPacksGrossValueListSuccess = (packsGrossValue) => ({
  type: actionTypes.FETCH_PACKS_GROSS_VALUE_LIST_SUCCESS,
  name: 'manageInventoryLoadingStatus',
  packsGrossValue
});

export const fetchPacksGrossValueListFailure = () => ({
  type: actionTypes.FETCH_PACKS_GROSS_VALUE_LIST_FAILURE,
  name: 'manageInventoryLoadingStatus',
});

export const fetchPacksGrossValue = (config) => async (dispatch, getState) => {
  try {
    const { session } = getState();
    const retailerId = config.retailerId || session.retailer.retailerId;

    const requestParams = {
      ...config,
      retailerId,
    };

    dispatch(fetchPacksGrossValueListRequest());

    const grossValue = await api.fetchPacksGrossValue(requestParams);

    dispatch(fetchPacksGrossValueListSuccess(grossValue));
  } catch (error) {
    console.error('FETCH_PACKS_GROSS_VALUE_LIST', error);
    dispatch(fetchPacksGrossValueListFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/actions/fetch-pack-list-gross-value.actions.js